import { combineReducers } from "redux";
// import * as auth from "app/modules/Auth/_redux/authRedux";
import storage from "redux-persist/lib/storage";
import persistReducer from "redux-persist/es/persistReducer";
import { baseApi } from "./baseAPI";


const rootPersistConfig = {
  key: "root",
  storage: storage,
  whitelist: [""],
};

export const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
});

// export const rootReducer = persistReducer(rootPersistConfig, reducers);